var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-column h-100 justify-content-between" },
    [
      _c("div", [
        _c("h4", { staticClass: "text-left text-primary" }, [
          _vm._v(_vm._s(_vm.$t("Welcome!"))),
        ]),
      ]),
      _c("div", [
        _c("div", { staticClass: "mt-3" }, [
          _c(
            "form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.onSubmit.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "fn-form-schema",
                {
                  ref: "formSchema",
                  attrs: { value: _vm.model, "no-inject": "" },
                  on: { input: _vm.onUpdate, validated: _vm.onValidated },
                },
                [
                  _c("fn-form-group", {
                    attrs: { schema: _vm.schema.first_name },
                  }),
                  _c("fn-form-group", {
                    attrs: { schema: _vm.schema.last_name },
                  }),
                  _c("fn-form-group", { attrs: { schema: _vm.schema.email } }),
                  _c("fn-form-group", {
                    attrs: { schema: _vm.schema.password },
                  }),
                  _c("fn-form-group", {
                    attrs: { schema: _vm.schema.password_confirmation },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "form-group mt-4" },
                [
                  _c(
                    "fn-ui-button",
                    {
                      staticClass: "btn-block btn-rounded",
                      attrs: {
                        variant: "primary",
                        disabled: _vm.flags.invalid || _vm.submitting,
                        submitting: _vm.submitting,
                        type: "submit",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Register")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "mt-4 pointer" },
          [
            _c(
              "router-link",
              {
                staticClass: "text-dark font-14",
                attrs: { to: _vm.loginRoute },
              },
              [_vm._v(" " + _vm._s(_vm.$t("Or Login")) + " ")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }